import {getEnabledFeatureGates} from "src/utils/featureUtils";
import {isKrakenRolloutPath} from "@amzn/atoz-kraken-utility";

export enum Stage {
  test = "test",
  alpha = "alpha",
  beta = "beta",
  prod = "prod",
}

export const HELPFUL_RESOURCES_BREADCRUMB_PAGE_NAME = "helpfulResources";
export const HELPFUL_RESOURCES_LITE_BREADCRUMB_PAGE_NAME = "helpfulResourcesLite";
export const HTTPS_URL_PREFIX = "https://";
export const NON_PROD_ASSET_ENDPOINT = "estech-myhr-assets.integ.amazon.com";
export const PROD_ASSET_ENDPOINT = "estech-myhr-assets.amazon.work";
export const NON_PROD_REQUESTING_DOMAIN = "integ.amazon.com";
export const PROD_REQUESTING_DOMAIN = "amazon.work";
export const KEY_PAIR_ID =  "K3N4PZYFCQ8L9J";
export const FPP_LE_ID_1 =  "FPPLE1";
export const FPP_LE_ID_2 =  "FPPLE2";
export const FPP_LE_ID_3 =  "FPPLE3";
export const FPP_LE_ID_4 =  "FPPLE4";
export const FPP_LE_ID_5 =  "FPPLE5";

export const ENGLISH_LOCALE = "en-US";
export const SPANISH_LOCALE = "es-ES";

export const MLE_FPP_VIDEO_FEATURE_GATE_NAME = "my_hr_mle_video_experience";
export const MLE_COMPLICATIONS_FEATURE_GATE = "my_hr_mle_complications_experience";
export const MLE_FPP_FAB_FEATURE_GATE = 'my_life_events_fpp_fab_enabled';
/**
 * PopStar gate controlling MLE's COREx content-source migration. The MyHR tenant prefix
 * is required because this app reads its feature list from the MyHR shell's
 * atoz-my-hr-app-root dataset.
 */
export const MLE_COREX_CONTENT_GATE = "my_hr_mle_corex_content";
/**
 * Content-source tag used on COREx.
 */
export const COREX_CONTENT_SOURCE = "COREX";
/**
 * Metric (latency) name for COREx's "/GetContentTranslation" operation.
 */
export const COREX_LATENCY_METRIC_NAME = "getContentTranslation";
/**
 * Operation names the AEM and TAS latency samples publish under, named for the same reason as
 * COREX_LATENCY_METRIC_NAME above.
 */
export const AEM_LATENCY_METRIC_NAME = "getTranslatedContentFromAEM";
export const TAS_LATENCY_METRIC_NAME = "getTranslatedContentFromTAS";
/**
 * Gateway routing key carrying the client id.
 */
export const MYHR_CLIENT_ID_QUERY_PARAM = "x-myhr-client-id";
/**
 * Generic "try again later" copy. Present in all 22 locale bundles under mle_fpp, and already
 * the default value of LifeEventStore.error, so no new string needs authoring or translating.
 */
export const GENERIC_ERROR_TRANSLATION_KEY = "error.unableToProcessRequest";
/**
 * Metric page names for the route-level error boundaries. Deliberately different from the
 * in-component boundaries' names (PolicyPage, JourneyPage). A route boundary firing means the
 * routed component's own render body threw, while an in-component boundary firing means a
 * descendant threw. The two need different investigations, so they must not share a dimension.
 */
export const POLICY_ROUTE_PAGE_NAME = "PolicyRoute";
export const ARTICLE_ROUTE_PAGE_NAME = "ArticleRoute";
export const TASK_PAGE_ROUTE_PAGE_NAME = "TaskPageRoute";
export const WILDCARD_ALL = "*";

export const FAB_CLIENT_ID = "AtoZ_MLE_FAB";

export const BASE_URL_MYHR_WORKFLOW_BETA = isKrakenRolloutPath() ? "https://essportal.integ.amazon.com/neverland-myhr?workflowId=" : "https://essportal.integ.amazon.com/myhr?workflowId="
export const BASE_URL_MYHR_WORKFLOW_PROD = "https://atoz.amazon.com/myhr?workflowId="
